// extracted by mini-css-extract-plugin
export var dividerContainer = "_98-0";
export var line = "_98-1";